export default {
  getMusicasEmEspera: state => state.musicasEmEspera,
  getMusicaEmEspera: state => state.musicaEmEspera,
}
